<template>
    <div id="Shopping">
        <topHead></topHead>
        <router-view />
        <div class="btmNav">
            <ul>
                <li v-for="(item,index) in nav" :key="index" @click="go(item.href,index)">{{item.title}}</li>
                <!-- <li>中医自测</li>
        <li>中医讲堂</li>
        <li>中草药</li>
        <li>中医文库</li>
                <li>经络穴位</li>-->
            </ul>
        </div>
        <vfooter></vfooter>
        <footerCopy></footerCopy>
    </div>
</template>

<script>
import vfooter from "@/components/common/Footer";
import topHead from "@/components/common/topHead";
import footerCopy from "@/components/common/footerCopy";
export default {
    name: "Shopping",
    data() {
        return {
            nav: [
                { title: "畅通圆首页", href: "/index" },
                { title: "中医自测", href: "/myYiAn" },
                { title: "中医讲堂", href: "/ForumIndex" },
                { title: "中草药", href: "/HerbalMedicineIndex" },
                { title: "中医文库", href: "/LibraryIndex" },
                { title: "经络穴位", href: "/JingLuoIndex" }
            ]
        };
    },
    components: {
        topHead: topHead,
        vfooter: vfooter,
        footerCopy: footerCopy
    },
    created() {
        // console.log(this.$route.path);
    },
    methods: {
        go(href,index) {
            this.$router.push({
                path:href,
                query:{i:index}
                });
        }
    }
};
</script>
<style scoped>
.btmNav {
    width: 100%;
    height: 50px;
    background: #eee;
    border-top: 1px solid #f6f6f6;
    border-bottom: 1px solid #f6f6f6;
    margin-top: 100px;
}
.btmNav ul {
    width: 900px;
    height: 50px;
    margin: 0px auto;
}
.btmNav ul li {
    float: left;
    height: 50px;
    line-height: 50px;
    padding: 0 10px;
    margin: 0 30px;
    font-weight: 600;
    color: #666;
    cursor: pointer;
}
</style>

<style>
#Shopping {
    background: #fbfbfb;
}
.bottomW {
    background-color: #fbfbfb;
}
/* 上方商品分类选项 */
.topList {
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #ccc;
}
.topList h3 {
    float: left;
    width: 150px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    background: #ffa42f;
    margin: 0;
    cursor: pointer;
    position: relative;
}
.topList-list {
    width: 150px;
    min-height: 350px;
    max-height: 500px;
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    z-index: 999;
    overflow-y: auto;
}
.topList-list ul {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 20px;
}
.topList-list ul li {
    width: 100%;
    height: 35px;
    line-height: 35px;
    color: #fff;
    font-size: 16px;
    font-weight: 100;
    border-bottom: 1px dashed #999;
}
.topList-list ul li span {
    height: 35px;
    line-height: 35px;
    display: block;
    width: 90%;
    float: left;
    text-align: left;
}
.topList-list ul li i {
    height: 35px;
    line-height: 35px;
    display: block;
    width: 10%;
    float: left;
}
.topList .nav {
    float: left;
    width: 80%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    letter-spacing: 1px;
    color: #666666;
}
.topList .nav li {
    float: left;
    padding: 0 10px;
    cursor: pointer;
}
/* 主题内容 */
.main {
    width: 100%;
    margin: 0px auto;
}
.main::after {
    content: "";
    height: 0;
    clear: both;
    overflow: hidden;
    display: block;
    visibility: hidden;
}


</style>



// WEBPACK FOOTER //
// src/components/ShoppingMall/index.vue